"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("van-nav-bar", {
    attrs: {
      title: _vm.transferTitle || _vm.pageTitle,
      fixed: true
    },
    on: {
      "click-left": _vm.onClickLeft,
      "click-right": _vm.onClickRight
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function fn() {
        return [_c("van-icon", {
          attrs: {
            name: "arrow-left",
            size: "22",
            color: "#141417"
          }
        })];
      },
      proxy: true
    }, !_vm.isShowFilterList.includes(_vm.$route.path) ? {
      key: "right",
      fn: function fn() {
        return [_c("span", {
          staticClass: "filter-span"
        }, [_vm._v("筛选"), _c("van-icon", {
          attrs: {
            name: "filter-o",
            size: "20",
            color: "#141417"
          }
        })], 1)];
      },
      proxy: true
    } : null], null, true)
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;